module.exports = __webpack_public_path__ + "media/images/story/top/capture_declaration-03e89455fb21bd26fdd30bc7c3bb65c8.svg";